import { useEdgeQuery } from '@app/data/edge/hooks';
import useCustomerMarket from '@drc/hooks/useCustomerMarket';
import useCountry from '@drc/hooks/useCountry';
import { useCurrency } from '@app/currency';
import { GET_USER_GENERATED_CONTENT_PRODUCTS } from '../queries/GetUserGeneratedContentProducts';

const useUserGeneratedContentProducts = (entryId: string) => {
  const { currency } = useCurrency();
  const { marketName: market } = useCustomerMarket();
  const country = useCountry();

  return useEdgeQuery(GET_USER_GENERATED_CONTENT_PRODUCTS, {
    variables: {
      id: entryId,
      currency,
      market,
      country,
    },
    enabled: !!entryId,
    select: (data) => ({
      products: data?.userGeneratedContentEntry?.products,
    }),
  });
};

export default useUserGeneratedContentProducts;
